module.exports = __webpack_public_path__ + "img/HZCBCN2HXXX.3ccb18bf.png";